export const OPERATOR_CLIENT = 'operator-http-client';
export const FOUNDATIONS_CLIENT = 'foundations-http-client';
export const FOUNDATION_WS_CLIENT = 'foundations-websockets-client';
export const QUALITY_USERLESS_CLIENT = 'quality-http-userless-client';
export const QUALITY_WS_CLIENT = 'quality-websockets-client';
